import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";

type TOrganizationWithAiModel = {
  id: number;
  name: string;
  defaultAiModelOverride: string | null;
};

export type TAiModelSettings = {
  isUsingOrganizationOverride: boolean;
  currentModel: string;
  source: "Organization Override" | "Innovera Default";
};

export function useAiModelSettings() {
  const { organizationId } = useMeStore();

  const { data: organizationData } = useQuery({
    queryKey: ["organizationAiModel", organizationId],
    queryFn: async (): Promise<TOrganizationWithAiModel> => {
      const response = await $api.get(`/organizations/${organizationId}/with-ai-model`);
      return response.data.data;
    },
    enabled: !!organizationId
  });

  const aiModelSettings: TAiModelSettings | null = organizationData
    ? {
        isUsingOrganizationOverride: !!organizationData.defaultAiModelOverride,
        currentModel: organizationData.defaultAiModelOverride || "Innovera Default",
        source: organizationData.defaultAiModelOverride ? "Organization Override" : "Innovera Default"
      }
    : null;

  return {
    aiModelSettings,
    isLoading: !organizationData,
    organizationData
  };
}
